import { QueryClientProvider } from '@tanstack/react-query'
import { I18nextProvider } from 'react-i18next'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'

import i18n from '@/locales/i18n'

import { AuthInit } from './AuthInit'
import { queryClient } from './queryClient'
import { router } from './router'

export const AppProviders = () => (
  <I18nextProvider i18n={i18n}>
    <QueryClientProvider client={queryClient}>
      <AuthInit>
        <RouterProvider router={router} />
      </AuthInit>
      <Toaster richColors position="top-center" />
    </QueryClientProvider>
  </I18nextProvider>
)
